// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QYNu","col":"styles_col__3GK4J"};